import { useState, useEffect } from "react";
import Icon from "../../assets/icons/Icon";
import { isMobileView } from "./CommonFunctions";

const Input = ({
  label,
  disabled,
  type,
  name,
  placeholder,
  value,
  onChange,
  errorMessage,
  starttext,
  endtext,
  handleEndtextOnclick,
  removeBtnOnclick,
  infoText,
  tooltipPosition = "bottom",
  tooltipOffset = "0",
  tooltipWidth = null,
  bgColor,
  min,
  max,
  dataAccessDays, // New prop: number of days allowed to select back from current date
  isMandatory,
  onEnter
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [disabledInput, setDisabledInput] = useState(false);
  const [minDate, setMinDate] = useState("");
  const [maxDate, setMaxDate] = useState("");

  const [showInfoText,setShowInfoText]=useState(false);

  useEffect(() => {
    setDisabledInput(!!disabled);
  }, [disabled]);
const handleKeyDown = (e) => {
  if (e.key === "Enter" && typeof onEnter === "function") {
    onEnter(e);
  }
};

  useEffect(() => {
    // Set date restrictions when dataAccessDays changes
    if (type === "date" && dataAccessDays) {
      const today = new Date();
      setMaxDate(today.toISOString().split('T')[0]); // Today's date in YYYY-MM-DD format
      
      const minDate = new Date();
      minDate.setDate(today.getDate() - dataAccessDays);
      setMinDate(minDate.toISOString().split('T')[0]);
    }
  }, [dataAccessDays, type]);

  const isPassword = type === "password";
  const inputType = isPassword && showPassword ? "text" : type;
  const isNumber = type === "number";
  const isDate = type === "date";

  const handleNumberChange = (e) => {
    const inputValue = e.target.value;
    
    // If input is empty, allow it (so user can delete the value)
    if (inputValue === "") {
      onChange(e);
      return;
    }
    
    // For number inputs, validate min/max if provided
    if (isNumber) {
      const numValue = parseFloat(inputValue);
      
      if (min !== undefined && numValue < min) {
        return;
      }
      
      if (max !== undefined && numValue > max) {
        return;
      }
    }
    
    // Call the parent's onChange handler
    onChange(e);
  };

  return (
    <div className={`flex flex-col w-full relative ${errorMessage ? "mb-3" : ""}`}>
      {label && (
        <label className={`inline-flex items-center gap-1 mb-1 ${errorMessage ? "text-red-700" : "text-[#000000]"}`}>
          {label} {isMandatory && <span className="text-red-700">*</span>}
          {infoText && (
            <div className="relative inline-flex group">
              <span onClick={()=>{setShowInfoText(!showInfoText)}} onMouseEnter={()=>{setShowInfoText(true)}} onMouseLeave={()=>{setShowInfoText(false)}} className="inline-flex items-center justify-center ml-1 border border-[rgb(108,113,138)] text-[rgb(108,113,138)] rounded-full w-4 h-4 text-center leading-4 text-xs cursor-pointer">
                i
              </span>
{showInfoText && (
  <div
    className={`
      z-50 px-3 py-2 rounded whitespace-normal
      ${isMobileView()
        ? `fixed left-0 justify-center flex w-full bg-[#4A1E73] text-[#FFFFFF] top-0 }`
        : `
          absolute bg-[#4A1E73] text-[#FFFFFF] 
          ${getTooltipPositionClasses(tooltipPosition)}
          ${tooltipOffset ? `m-${tooltipOffset}` : ""}
        `
      }
    `}
    style={{
      width: isMobileView() ? "100%" : tooltipWidth || undefined,
    }}
  >
    {isMobileView() && (
      <span
        className="absolute top-2 right-2 w-6 h-6 bg-red-500 rounded-full flex items-center justify-center cursor-pointer shadow-lg hover:bg-red-600 transition-colors"
        onClick={(e) => {
          e.stopPropagation();
          setShowInfoText(false);
        }}
        aria-label="Close tooltip"
      >
        <span className="w-4">
          <Icon type="remove" />
        </span>
      </span>
    )}
    {infoText}
  </div>
)}

            </div>
          )}
        </label>
      )}
      <div
        className={`flex border text-gray-700 outline-none w-full rounded-lg transition-all duration-300 ${
          errorMessage ? "border-red-700" : "border-[#d7d5e2] hover:border-[#408dfb] focus-within:shadow-[0_0_0_3px_rgba(64,_141,_251,_0.16)]"
        } ${
          disabled ? 'bg-[#EEEEEE] cursor-not-allowed' : 'bg-white'
        }`}
        style={{ height: "34px" }}
      >
        {starttext && (
          <span className="pl-2 rounded-l-lg text-[#21263c] flex bg-[#f9f9fb] items-center justify-center text-[13px] pr-1 border-[#d7d5e2]">
            {starttext}
          </span>
        )}
        <div className="relative flex-grow flex items-center">
          <input
            disabled={disabledInput}
            type={inputType}
            placeholder={placeholder}
            value={value}
            name={name}
            onChange={isNumber ? handleNumberChange : onChange}
            className={`${disabled && "cursor-not-allowed"} pl-2 inline-block w-full outline-none h-full`}
            min={isDate ? minDate : min}
            max={isDate ? maxDate : max}
            onKeyDown={handleKeyDown}  
          />
          {value != null && value !== "" && removeBtnOnclick && (
            <span
              className="pr-2 w-9 flex items-center justify-center text-[14px] cursor-pointer hover:text-[#408dfb] text-[#21263c]"
              onClick={removeBtnOnclick}
            >
              <Icon type="remove" />
            </span>
          )}
        </div>
        {endtext && (
          <span
            onClick={handleEndtextOnclick}
            className="text-nowrap cursor-pointer hover:text-[#408dfb] pl-1 pr-2 rounded-r-lg text-[#21263c] flex items-center justify-center text-[13px] pr-1 border-l border-[#d7d5e2]"
          >
            {endtext}
          </span>
        )}
        {isPassword && (
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="flex items-center justify-center px-2 text-gray-600 hover:text-gray-800"
          >
            {showPassword ? (
              <span className="inline-block w-5">
                <Icon type="eyeopen" />
              </span>
            ) : (
              <span className="inline-block w-6">
                <Icon type="eyeclose" />
              </span>
            )}
          </button>
        )}
      </div>
      {errorMessage && (
        <p className="mt-1 top-full text-sm absolute text-red-700">{errorMessage}</p>
      )}
    </div>
  );
};

const getTooltipPositionClasses = (position) => {
  switch(position) {
    case 'top': return 'bottom-full left-1/2 -translate-x-1/2 mb-2';
    case 'bottom': return 'top-full left-1/2 -translate-x-1/2 mt-2';
    case 'left': return 'right-full top-1/2 -translate-y-1/2 mr-2';
    case 'right': return 'left-full top-1/2 -translate-y-1/2 ml-2';
    default: return 'bottom-full left-1/2 -translate-x-1/2 mb-2';
  }
};

export default Input;